module.exports = __webpack_public_path__ + "img/logo.8c50e8a4.png";